/**
 * Scope as a map (tracks, epics, priority, relations) or as the three columns.
 * Which one is a viewer's own choice, kept in this browser.
 */

import { useState } from 'react'
import { Tab, TabList, makeStyles, tokens } from '@fluentui/react-components'
import { ColumnTriple20Regular, Organization20Regular } from '@fluentui/react-icons'
import type { Plan, PlanEdit, PlanState } from '../../types/planning'
import { PlanMap } from './PlanMap'
import { ScopeBoard } from './ScopeBoard'

const KEY = 'planning.scopeView'
type View = 'map' | 'cols'

function stored(): View {
  try {
    return localStorage.getItem(KEY) === 'cols' ? 'cols' : 'map'
  } catch {
    return 'map'
  }
}

const useStyles = makeStyles({ tabs: { marginBottom: tokens.spacingVerticalS } })

export function ScopeView(props: { plan: Plan; state: PlanState; edit: (e: PlanEdit) => void; cycle?: string }) {
  const styles = useStyles()
  const [view, setView] = useState<View>(stored)
  const pick = (v: View) => {
    setView(v)
    try {
      localStorage.setItem(KEY, v)
    } catch {
      // A private window: the choice lasts this visit.
    }
  }
  return (
    <>
      <TabList
        className={styles.tabs}
        size="small"
        selectedValue={view}
        onTabSelect={(_, d) => pick(d.value as View)}
        aria-label="Scope view"
      >
        <Tab value="map" icon={<Organization20Regular />}>
          Map
        </Tab>
        <Tab value="cols" icon={<ColumnTriple20Regular />}>
          Columns
        </Tab>
      </TabList>
      {view === 'map' && <PlanMap {...props} />}
      <ScopeBoard {...props} columns={view === 'cols'} />
    </>
  )
}
